
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_6_345)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.207 7.793a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414l3.293 3.293 6.293-6.293a1 1 0 011.414 0z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6_345"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"4","fill":"#fff"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      